import React from 'react';
import {
    Box,
    Heading,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    ListItem,
    UnorderedList,
    Text
} from '@chakra-ui/react';
import './fonts/fonts.css';

const applicationQuestions = [
    {
        question: "How many campers will CYLC take? How many groups and what is the group size?",
        answer: "CYLC will take 400 applicants, including assistant counselors and counselors. There are anywhere between eight to ten teams, and each team has on average 25-35 campers (balanced by gender)."
    },
    {
        question: "Which website should I go to for the Application, or will the link be distributed through email?",
        answer: "Please check on www.cylc-dfw.org and go to the Application tab to find the information. You may also refer to CYLC’s Facebook page to obtain the updated information. CYLC will send an email reminder, but it is your responsibility to check the website regularly for details or updates as changes may occur during the process."
    },
    {
        question: "When will the Applications be available online?",
        answer: (
            <>
                <Text>
                    Step 1 Applications open on Monday, 1/12/26 at 8:00pm (Central Standard Time).
                </Text>
                <Text mt={2}>
                    Registration is open to all applicants who are at least 10 years old by 8/31/2026.
                    The Assistant Counselor application is open to all who are at least 15 years old by 8/31/2026.
                </Text>
                <Text mt={2} fontStyle="italic">
                    *Please be honest when filling out the birthday and grade level on the application. CYLC reserves the right to reject any application with false information. CYLC reserves the right to verify an applicant’s birthday or school grade level, as any “incorrect” birthday or grade level may cause disqualification. CYLC may request the birth certificate or school report card as a reference.
                </Text>
            </>
        )
    },
    {
        question: "How soon should I mail in my check?",
        answer: "Please submit the Google Form and mail the camp fee check of $750 to CYLC, P.O. Box 868156, Plano, TX 75086 soon after. Mailed checks must be postmarked on or before Friday, 2/6/26. Applications are not considered complete until the check is received and spots are filled on a first come, first come basis."
    },
    {
        question: "Will I get a confirmation after completing the Application?",
        answer: "You will receive an email copy of your Google form response after submitting the Google Form. Please save those email copies of your responses for your records. Once your mailed camp fee check of $750 is received, you will receive an email from CYLC (cylcdfw@gmail.com) notifying you of the completed application and accepted spot into CYLC 2026."
    },
    {
        question: "I messed up my application; can I make a change without affecting whether or not I get in?",
        answer: "It is your responsibility to follow the application process and carefully check all the documents before submission. Any mistakes may adversely affect the processing of your application, especially for contact information such as email address and cell numbers. The uniform size will also be based on what is recorded on the application."
    },
    {
        question: "Is there a place I can specify who I want to room with during camp?",
        answer: "Yes, please specify who you want to room with during camp. CYLC will assign a roommate for you if your roommate did not get in or you did not specify a roommate in your Application Form. You may specify who you do not want to room with as well, but there is no guarantee either way. We will do our best to accommodate all requests."
    },
    {
        question: "Can I pay the camp fee online? For example by Paypal or credit card? What method of payment will be accepted for the camp?",
        answer: "No, online payments are not accepted. Only personal checks and money orders are accepted for camp. Any returned check penalty will be paid by the applicant. This check will be mailed in as part of the Application."
    },
    {
        question: "May I register the camper after the deadline of February 6th?",
        answer: "Yes. If there are additional camper spots available after Friday, 2/6/26, CYLC may keep the Application Form open. Please email CYLC (cylcdfw@gmail.com) to inquire about the availability of spots if unsure."
    }
];



const counselorQuestions = [
    {
        question: "Do I need to do the camper Application if I am applying to be an assistant counselor (AC) or counselor (C)?",
        answer: "Yes, assistant counselor and counselor applicants all need to complete the application in order to secure their room at camp. You may only apply online for counselor (C) or assistant counselor (AC) after completing application. We have limited spots; there is no privilege for past counselors or assistant counselors in the application. Please follow the process carefully as instructed."
    },
    {
        question: "How can I submit my counselor application package?",
        answer: "We have set up a Google Form for you to submit your question answers, resume, essay, and code of conduct."
    },
    {
        question: "How long do my answers to the questions need to be?",
        answer: "Answers should be concise and clear. We are looking for creative ideas and practical solutions."
    },
    {
        question: "How long does my essay need to be?",
        answer: "The essay is 250-650 words. Longer is not better as long as you adequately address the prompts."
    },
    {
        question: "Are grades/rank a major factor in selecting C/ACs? What factors are considered?",
        answer: "No, CYLC provides equal opportunities for all candidates. The school ranking/grades are not the major factors for selection. CYLC is looking for leadership traits like creativity, confidence, integrity, responsibility, and having a positive attitude. It is most important to be a good team player and a good role model for campers."
    },
    {
        question: "I have absolutely no talent for dancing. How will this affect my candidacy?",
        answer: "CYLC is not a dance camp, but dance is a fun way to present your teamwork skills. Your actual skill level will not affect your counselor selection, but it is important to keep a positive attitude as that will be considered more heavily during the review process."
    },
    {
        question: "How can I improve my application?",
        answer: "Be yourself. CYLC does not have any cookie-cutter requirements in its counselor candidates. Each candidate will be considered individually and evaluated holistically based on his or her individual strengths and weaknesses. Pay attention to details and make your application look professional (e.g., make sure your application, resume, essay and picture are nice and clean). Each interview is 5-10 minutes long. Let the teachers get to know you, and you may always seek more practice by asking your parents for tips or speaking with past counselors for additional advice prior to the interview."
    },
    {
        question: "If I don’t make C/AC, will I be a camper?",
        answer: "Yes, you will keep your spot as a camper. The ratio of C/AC selection rate is historically about 50%, but this is a great opportunity for you to prepare yourself early for college applications and interviews. Every step of the C/AC application process is important. CYLC hopes this experience can help you build up confidence and also polish other leadership skills."
    },
    {
        question: "I have never been to CYLC camp before; can I still apply to be a counselor?",
        answer: "Yes, you have the same opportunities as other candidates who have attended CYLC before."
    },
    {
        question: "What is the counselor training schedule for 2026?",
        answer: (
            <UnorderedList>
                <ListItem>The Counselor/Assistant Counselor application due date is Friday, 2/13/26. You will be notified of your interview time by Saturday, 2/21/26. If you cannot make your scheduled time, you must arrange yourself to switch with another candidate and notify CYLC at (cylcdfw@gmail.com) by Saturday, 2/28/26.</ListItem>
                <ListItem>Counselor interviews: Saturday, 3/7/26 - Sunday, 3/8/26</ListItem>
                <ListItem>Meet & Greet: Saturday, 3/28/26</ListItem>
                <ListItem>Counselor Trainings: 6/20-6/21, 6/27-6/28, 7/11-7/12</ListItem>
                <ListItem>Move-in date: Sunday, 7/19</ListItem>
            </UnorderedList>
        )
    },
    {
        question: "Am I required to attend all trainings? If I have an unscheduled emergency and I miss more trainings than allowed, will I be disqualified?",
        answer: (
            <>
                <Text>CYLC counselor training is very important. Please arrange your schedule accordingly so as not to conflict with the counselor training schedule, especially for new assistant counselors. Missing any session will make it hard for you and your team to evenly divide the workload and will be unfair to other counselors.</Text>
                <Text mt={2}>Counselors and Assistant Counselors may only be excused from a maximum of two trainings, however the training sessions on July 11-12 and Move in Day July 19 are mandatory. With the exception of illness and emergencies, all excused absences must be disclosed in advance and preapproved by the CYLC committee. C/ACs with any unexcused absences or who miss a training not due to special circumstances (e.g., illness or emergencies) will be removed from the C/AC team. Tardiness or early departure is considered an absence. Reasonable exceptions will be considered on a case-by-case basis. Please note that 7/11 is an ACT date--if you are taking the ACT on this date, you must notify the CYLC team by Meet and Greet as that is the only excusable absence in the morning of that mandatory date.</Text>
                <Text mt={2}>NOTE: The dates and training location may be changed subject to availability - CYLC will notify C/ACs by email in the event of any changes. Each C/AC team will need to do some additional work outside of the three training weekends. It is very important for C/ACs to commit to the training schedule so that we can be prepared for camp.</Text>
            </>
        )
    }
];


const ApplicationFAQ = () => {
    return (
        <Box bg="FFFFEA" p={"5%"} maxWidth="90%" mx="auto">
            <Heading fontSize="3vw" textAlign="center" mb={"4%"} fontFamily={"Nohemi"}>
                Frequently Asked Questions
            </Heading>

            <Heading fontSize="2.5vw" textAlign="left" mb={"2%"} mt={"4%"} fontFamily={"Nohemi"}>
                Application Process
            </Heading>
            <Accordion allowToggle fontSize={{ base: "2vw", lg: "1.5vw", "2xl": "1vw" }} fontFamily={"NohemiLight"}>
                {applicationQuestions.map((item, index) => (
                    <AccordionItem key={index}>
                        <AccordionButton>
                            <Box flex="1" textAlign="left" fontWeight="bold" fontSize={{ base: "2vw", lg: "1.5vw", "2xl": "1vw" }}>
                                {item.question}
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4}>{item.answer}</AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>



            <Heading fontSize="2.5vw" textAlign="left" mb={"2%"} mt={"4%"} fontFamily={"Nohemi"}>
                Counselor/Assistant Counselor Application Questions
            </Heading>
            <Accordion allowToggle fontSize={{ base: "2vw", lg: "1.5vw", "2xl": "1vw" }} fontFamily={"NohemiLight"}>
                {counselorQuestions.map((item, index) => (
                    <AccordionItem key={index}>
                        <AccordionButton>
                            <Box flex="1" textAlign="left" fontWeight="bold" fontSize={{ base: "2vw", lg: "1.5vw", "2xl": "1vw" }}>
                                {item.question}
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4}>{item.answer}</AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </Box>
    );
};

export default ApplicationFAQ;
